module.exports = __webpack_public_path__ + "static/media/stockhausen_ganzeteile_1.59623b9f.png";